import { render, staticRenderFns } from "./post-tab.vue?vue&type=template&id=c5b042ba"
import script from "./post-tab.vue?vue&type=script&lang=js"
export * from "./post-tab.vue?vue&type=script&lang=js"
import style0 from "./post-tab.vue?vue&type=style&index=0&id=c5b042ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports